import React, { useState } from 'react';
import { useHistory } from 'react-router'
import { Modal, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab'

// Styles
import '../../assets/styles.css'

// Logo
import logo_trans from '../../assets/logo_trans.png';

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'

export default function LoginComponent() {

    const history = useHistory()

    // Loading
    const [isLoadingModalOpen, setLoaginModalOpen] = useState(false)

    // Snackbar
    const [alertSeverity, setAlertSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertDuration, setAlertDuration] = useState(3000)
    const [alertOpen, setAlertOpen] = useState(false)

    function showAlert(severity, message, duration) {
        setAlertSeverity(severity)
        setAlertMessage(message)
        setAlertDuration(duration)
        setAlertOpen(true)
    }

    function login() {
        
        // Define variables
        const email = document.getElementById('emailInput').value.toString().trim()
        const password = document.getElementById('passwordInput').value.toString().trim()

        // Login and error control.
        if(email !== '' && password !== '') {

            setLoaginModalOpen(true)

            firebase.auth().signInWithEmailAndPassword(email, password).then(() => {

                setLoaginModalOpen(false)
                history.replace('/home')

            }).catch((error) => {

                setLoaginModalOpen(false)
                console.error(error)
                
                switch (error.code) {
                    case 'auth/user-not-found':
                        showAlert('error', 'No existe ningún usuario con estas credenciales.', 3000)
                        break;
                        
                    case 'auth/wrong-password':
                        showAlert('error', 'La contraseña no es correcta.', 3000)
                        document.getElementById('passwordInput').value = ''
                        break;
                
                    default:
                        showAlert('error', 'Ha ocurrido un error, inténtalo de nuevo más tarde.', 3000)
                        break;
                }
            })
        }
    }

    return(
        <div className='container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
            <br></br>
            <br></br>
            <div className='row' style={{ width: '100%'}}>
                <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                <div className='col-sm-10 col-md-8 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                    <img src={logo_trans} style={{ width: '80%' }} alt='This is a logo' ></img>
                </div>
                <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
            </div>
            <div className='row' style={{ width: '100%'}}>
                <div className='col-sm-2 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                <div className='col-sm-8 col-md-8 col-lg-4 col-xl-4 col-xxl-4'>
                    <form style={{ padding: 20, width: '100%' }}>
                        <div className="mb-3">
                            <input type='email' className='form-control' id='emailInput' placeholder='E-mail' />
                        </div>
                        <div className="mb-3">
                            <input type='password' className='form-control' id='passwordInput' placeholder='Password' autoCapitalize='none' />
                        </div>
                    </form>
                    <div style={{ width: '100%' }} className='text-center' >
                        <button type='button' className='btn btn-primary' style={{ width: '90%'}} 
                        onClick={() => {
                            login()
                        }} >
                            Entrar
                        </button>
                    </div>
                </div>
                <div className='col-sm-2 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
            </div>
            {/**
             * 
             * MODAL ZONE
             * 
             */}
            <Modal
            disableEnforceFocus
            open={isLoadingModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
                </div>
            </Modal>
            {/**
             * 
             * SNACKBAR
             * 
             */}
            <Snackbar
            open={alertOpen}
            autoHideDuration={alertDuration}
            onClose={() => {
                setAlertOpen(false)
            }} >
                <Alert 
                variant='filled'
                severity={alertSeverity} >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/login/LoginComponent.js